import extraterrestrial_solar_radiation_table from './temperature/esr.js'
import texture from './soil/texture.js'
import dropper_types from './irrigation/dropper_types.js'
import irrigation_systems from './irrigation/irrigation_systems.js'
import ea from './irrigation/ea.js'
import crop_type_varieties from './crop/crop_type_varieties.js'
import crop_type_list from './crop/crop_type_list.js'

const plot_params = {
    esr: extraterrestrial_solar_radiation_table,
    soil_textures: texture,
    dropper_types: dropper_types,
    irrigation_systems: irrigation_systems,
    application_efficiency: ea,
    crop_type_varieties: crop_type_varieties,
    crop_type_list: crop_type_list,
};

export default plot_params;